import Controller, { OnClose } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../BaseController';
import { FragmentNames, SecurityDeactivationModalAliases } from '../../codegen';
import { ContextType } from '@philips-internal/oswald-ui-core';
import { SubmittableFragmentContext } from '@philips-internal/oswald-ui-core/lib/component';
import { SubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { Inject } from '@odinjs/odin';

@Controller({ fragment: FragmentNames.SECURITY_DEACTIVATION_MODAL })
export default class SecurityDeactivationModalController extends BaseController {

  @Inject(ContextType.SUBMITTABLE_FRAGMENT)
    submittableFragmentContext!: SubmittableFragmentContext;

  @OnClose({ target: SecurityDeactivationModalAliases.MODAL_SECURITY_DEACTIVATION })
  onSecurityModalClose(): void {
    this.submittableFragmentContext.cancel(new SubmitEvent());
  }

}
